import * as React from 'react';
import Loading from '@doordash/component-loading';
/**
 * Having a red loading spinner as code split loader,
 * so if the site crash on red spinner we know the code split went wrong
 */
var CodeSplitLoadingSpinner = function () { return (React.createElement(Loading, { size: Loading.Sizes.Medium, color: Loading.Colors.SystemRed30 })); };
export default CodeSplitLoadingSpinner;
